'use client'
import React, { type LegacyRef } from 'react'

import type { ShareAbleTime } from '@/api/client/purchase/dto/purchaseDto'
import Button from '@/shared/components/button/Button'
import Icons from '@/shared/components/icon/Icons'
import { Caption, Text } from '@/shared/components/typography'
import { formatTime, generateParkingEndTime } from '@/shared/utils/date'

import SharedTimeNotice from '../sharedTimeNotice/view'

import { roboto } from '@/styles/font'

const SharedEnteringTime = ({
  onClickTimeValue,
  selectedIndex,
  time,
  onClickTimeNextBtn,
  enteringTime,
  handleSharedNoticeOpen,
  contentHeight,
  isSharedNoticeOpen,
  footerRef
}: {
  time: ShareAbleTime[]
  selectedIndex: number | null
  onClickTimeValue: (i: number) => void
  onClickTimeNextBtn: () => void
  enteringTime: number
  handleSharedNoticeOpen: () => void
  contentHeight: number
  isSharedNoticeOpen: boolean
  footerRef: LegacyRef<HTMLDivElement>
}) => {
  const timeNoticeText = enteringTime ? `여유 시간 10분을 추가한 시간입니다.` : '주차 중 이동을 지양해주세요.'
  return (
    <>
      <div className={`flex flex-1 justify-center`} style={{ height: contentHeight, overflow: 'scroll' }}>
        <div className="flex flex-col items-center flex-1 pt-4 bg-010">
          <Text level="text1" color="text090" weight="bold">
            주차 시간을 선택해 주세요.
          </Text>
          <div className={`${roboto.className} mt-10 flex w-full flex-col bg-010 text-center`}>
            {time.map((item, i) => (
              <div
                key={i}
                className={`cursor-pointer py-[20px] ${selectedIndex === i ? 'bg-main-010 font-medium' : ''}`}
                onClick={() => onClickTimeValue(i)}
              >
                <Text level="text2" color="text090">
                  {`${formatTime(item.usingTime)}`}
                </Text>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={`sticky bottom-0 flex w-full flex-col gap-3 bg-010 px-4 py-3`}>
        <div className="flex flex-col items-center gap-1 pt-5 pb-5 rounded-md bg-020">
          <Text level="text2" color="text090" weight="bold">
            지금부터{' '}
            <span className={enteringTime ? ' text-main-050' : 'font-normal text-text-070'}>
              {enteringTime ? generateParkingEndTime(enteringTime) : '종료 시간까지'}
            </span>{' '}
            주차하기
          </Text>
          <Caption level="caption2" color={`${enteringTime ? 'text070' : 'main050'}`} className="cursor-pointer">
            <div
              onClick={handleSharedNoticeOpen}
              className={`ml-[9px] flex items-center gap-[2px] ${enteringTime && 'cursor-default'}`}
            >
              <span className={`${enteringTime ? '' : 'underline'}`}>{timeNoticeText}</span>
              {!enteringTime && <Icons.LeftIcon stroke="currentColor" color="##0099FF" />}
            </div>
          </Caption>
        </div>
        <div className="sticky bottom-0" ref={footerRef}>
          <Button
            text="다음"
            color="text010"
            background="bg030"
            onClick={onClickTimeNextBtn}
            disabled={!enteringTime}
            className="body-1 h-[56px]"
            pyValue="py-0"
          />
        </div>
      </div>
      <SharedTimeNotice isOpen={isSharedNoticeOpen} onClose={handleSharedNoticeOpen} onClick={handleSharedNoticeOpen} />
    </>
  )
}

export default SharedEnteringTime
